import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Loader from "../../components/common/Loader";
import ErrorState from "../../components/common/ErrorState";
import EmptyState from "../../components/common/EmptyState";
import applicationStatusService from "../../services/applicationStatusService";
import { useStudentAuth } from "../../context/StudentAuthContext";
import { formatDate } from "../../utils/format";
import logo from "../../assets/logo.png";

const STATUS_LABEL = {
  applied: "Applied",
  in_process: "In process",
  shortlisted: "Shortlisted",
  selected: "Selected",
  rejected: "Not selected",
};

export default function StudentDashboard() {
  const { account, logout } = useStudentAuth();
  const [apps, setApps] = useState([]);
  const [state, setState] = useState("loading");

  function load() {
    setState("loading");
    applicationStatusService
      .myApplications()
      .then((res) => {
        setApps(res.data || []);
        setState((res.data || []).length ? "ready" : "empty");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, []);

  return (
    <div className="pm-student-shell">
      <header className="pm-student-topbar">
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <div className="pm-student-topbar__right">
          <span>{account?.full_name}</span>
          <button className="pm-btn pm-btn--ghost pm-btn--sm" onClick={logout}>Log out</button>
        </div>
      </header>

      <div className="pm-page">
        <header className="pm-page__header">
          <div>
            <span className="pm-eyebrow">My applications</span>
            <h1>Hi {account?.full_name?.split(" ")[0] || "there"} 👋</h1>
          </div>
          {/* <a href="/#opportunities" className="pm-btn pm-btn--primary">+ Apply to another campus</a> */}
          {apps.length === 0 && (<a href="/#opportunities" className="pm-btn pm-btn--primary"> + Apply to campus </a>)}
        </header>

        {state === "loading" && <Loader label="Loading your applications" />}
        {state === "error" && <ErrorState onRetry={load} />}
        {state === "empty" && (
          <EmptyState
            title="You haven't applied yet"
            description="Browse open campuses and submit your first application."
            action={<a href="/#opportunities" className="pm-btn pm-btn--primary" style={{ marginTop: 12 }}>Browse campuses</a>}
          />
        )}

        {state === "ready" && (
          <div className="pm-app-card-grid">
            {apps.map((a, i) => (
              <motion.div
                key={a.id}
                className="pm-app-card"
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: Math.min(i, 6) * 0.05 }}
              >
                <div className={`pm-status-pill pm-status-pill--${a.overall_status}`}>
                  {STATUS_LABEL[a.overall_status] || a.overall_status}
                </div>
                <h3>{a.university_name}</h3>
                <p>Applied {formatDate(a.applied_date)}</p>
                {a.current_round_name && (
                  <p className="pm-app-card__round">Current stage: {a.current_round_name}</p>
                )}
                {a.video_scan_status === "pending" && (
                  <p className="pm-app-card__scan">Video is being verified…</p>
                )}
                <Link to={`/student/applications/${a.id}`} className="pm-table__link">
                  View details →
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}